import { render, staticRenderFns } from "./NotificationBarMessage.vue?vue&type=template&id=2fd03369"
import script from "./NotificationBarMessage.vue?vue&type=script&lang=js"
export * from "./NotificationBarMessage.vue?vue&type=script&lang=js"
import style0 from "./NotificationBarMessage.vue?vue&type=style&index=0&id=2fd03369&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports